const t = {
  "dates-container--content": "styles-module__dates-container--content___jlwdt",
  "dates-container--content-with-warning": "styles-module__dates-container--content-with-warning___kpOIO",
  "dates-container--footer": "styles-module__dates-container--footer___AIrOB",
  "dates-container--footer-actions": "styles-module__dates-container--footer-actions___fLSg-",
  "dates-container--submit-button": "styles-module__dates-container--submit-button___ALopW",
  "dates-container--reset-button": "styles-module__dates-container--reset-button___AFQ6u",
  "dates-container--content-expanded": "styles-module__dates-container--content-expanded___tGFKb"
};
export {
  t as default
};
